import React, { lazy, Suspense } from 'react';
import ErrorBoundary from '../../_modules/error/error_boundary';
import VehicleConfiguratorStore from '../../_flux/stores/vehicle_configurator_store';
import VehicleCatalogFilterOptionsStore from '../../_flux/stores/catalog_filter_options_store/vehicle';
import { FilterAvailableOptionsStore } from '../../_flux/stores/filter_available_options_store';
import { onConfiguratorClose } from './on_configurator_close';
import { onBackClick } from './on_back_click';
import { onConfiguratorValueChangeFactory } from './on_configurator_value_change_factory';
import { onConfiguratorSubmitFactory } from './on_configurator_submit_factory';
import { onShowInfo } from './on_show_info';
import { types } from '../../_constants/product/types';
import { handleView } from '../handle_view';
import { onVehiclePostcodeInputLeave } from '../../_flux/actions/vehicle_configurator_actions';
import LastUsedConfiguratorStore from '../../_flux/stores/last_used_configurator_store';

const VehicleConfiguratorComponent = React.lazy(() => import('../../_flux/components/vehicle_configurator/vehicle_configurator'));
const render = (states, options) => (
    <ErrorBoundary>
        <Suspense fallback={<div>Loading...</div>}>
            <VehicleConfiguratorComponent
                staticUrl={TYROOLA.globals.staticImagesUrl}
                store={TYROOLA.globals.store}
                state={states.state}
                isVehicleProvided={states.lastUsedConfigurator.isVehicleProvided}
                options={states.vehicleOptions}
                availableOptions={states.availableOptions}
                onClose={onConfiguratorClose}
                onChange={options.onConfiguratorValueChange}
                onSubmit={options.onConfiguratorSubmit}
                onBackClick={onBackClick}
                groupDimensionOptions={options.tyreType !== types.TYRE_MOTO}
                onShowInfo={onShowInfo}
                onBlur={onInputLeave}
            />
        </Suspense>
    </ErrorBoundary>
);

const stores = {
    state: VehicleConfiguratorStore,
    vehicleOptions: VehicleCatalogFilterOptionsStore,
    lastUsedConfigurator: LastUsedConfiguratorStore,
    availableOptions: FilterAvailableOptionsStore,
};

const onInputLeave = () => {
    onVehiclePostcodeInputLeave(VehicleConfiguratorStore.getState().values.postcode);
}

const getOptions = options => ({
    ...options,
    onConfiguratorValueChange: onConfiguratorValueChangeFactory(options.productType),
    onConfiguratorSubmit: onConfiguratorSubmitFactory(options.productType),
});

export const init = (container, options) =>
    handleView(stores, render, getOptions(options), container);
